import { getOWAConnectedAccount } from '../selectors';
import { getDefaultLogonEmailAddress } from 'owa-session-store';
import { getAccountIdByEmailAddress } from 'owa-mail-account-store/lib/utils/getAccountIdByEmailAddress';
import { getAccountSourceById } from 'owa-mail-account-store/lib/selectors/getAccountSourceById';
import { isMonarchMultipleAccountsEnabled } from './flights';

/***
 * Function that checks whether the email address belongs to the connected account
 *
 * Note: In the multi-account by sourceId scenarios (ie. native host), all accounts are
 * stored in owa-account-store, but much of our existing OWA code depends on the AAD
 * accounts not being considered 'connected accounts'. For now, we return false for all
 * AAD accounts. Cleaning up this confusion will be tracked by VSO# 127698.
 */
export function isConnectedAccount(emailAddress: string): boolean {
    if (isMonarchMultipleAccountsEnabled()) {
        const account = getAccountSourceById(getAccountIdByEmailAddress(emailAddress));
        if (account && account.mailbox?.mailboxType == 'OFFICE365') {
            return false;
        }
    } else {
        if (emailAddress == getDefaultLogonEmailAddress()) {
            return false;
        }
    }

    const account = getOWAConnectedAccount(emailAddress);
    return account !== undefined;
}
